import React, { Component } from "react";
import './SolicitacaoCadastroArquivosGrandesVolumes.css';
import { SolicitacaoArquivoGrandesVolumesHistory } from "./History";
import { SolicitacaoArquivoGrandesVolumesAttachments } from "./Attachments";

export const SolicitacaoArquivoGrandesVolumesAttachmentsAndHistory =

class extends Component {

	render() {
		return (
			<div>
				{this.renderForm()}
			</div>
		);
	}

	renderForm() {
		const { solicitacao, habilitaEdicaoAnexo, keyHistory } = this.props;

		return(
			<div className="br-form">
				<div className="row">
					<div className="col-md">
						<div className="field">
							<div className="input">
								<label>Documentação do conjunto de arquivos de grandes volumes:</label>
								{solicitacao.id &&
									<SolicitacaoArquivoGrandesVolumesAttachments solicitacao={solicitacao} habilitaEdicaoAnexo={habilitaEdicaoAnexo} key={keyHistory ? keyHistory : solicitacao.situacao}/>
								}
							</div>
						</div>
					</div>
					<div className="col-sm-5">
						<div className="field">
							<div className="input">
								<label>Histórico:</label>
								{solicitacao.id &&
									<SolicitacaoArquivoGrandesVolumesHistory solicitacao={solicitacao.id} key={keyHistory ? keyHistory : solicitacao.situacao}/>
								}
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}
